import { render, staticRenderFns } from "./PaisPage.vue?vue&type=template&id=959651ec"
import script from "./PaisPage.js?vue&type=script&lang=js&external"
export * from "./PaisPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports